import { useEffect, useState } from "react";
import Table from "../../components/tabular/Table";
import ManageSetup from "./ManageSetup";
import { FormField, SetupKind } from "../../helpers/types";
import { useLazyQuery } from "@apollo/client";
import { GET_ALL_USERS, GET_SETUPS } from "../../graphql/queries";
import BulkSetups from "./BulkSetups";
import usePagination from "../../hooks/usePagination";
import DeleteSetup from "./DeleteSetup";
import { downloadExport } from "../../helpers/exportDownload";
import SearchBox from "../../components/SearchBox";

type SetupDataType = {
  name: SetupKind;
  singular: string;
  fields: FormField[];
};

const SETUP_DATA: SetupDataType[] = [
  {
    name: "zones",
    singular: "zone",
    fields: [
      { name: "name", label: "Name", options: { required: true } },
      {
        name: "zone_manager_id",
        label: "Zone Manager",
        options: { required: true },
        type: "select_users",
      },
    ],
  },
  // {
  //   name: "account_groups",
  //   singular: "Account Group",
  //   fields: [
  //     { name: "name", label: "Name", options: { required: true } },
  //     {
  //       name: "zone_id",
  //       label: "Zone",
  //       type: "select_setups",
  //       options: {
  //         required: true,
  //         setup: "zones",
  //       },
  //       setupKind: "zones",
  //     },
  //     {
  //       name: "account_manager_id",
  //       label: "Account Manager",
  //       options: { required: true },
  //       type: "select_users",
  //     },
  //   ],
  // },
  {
    name: "transporters",
    singular: "transporter",
    fields: [
      { name: "name", label: "Name", options: { required: true } },
      { name: "email", label: "Email", options: { required: true } },
      { name: "phone", label: "Phone", options: { required: true } },
      { name: "phone", label: "Phone", options: { required: true } },
      { name: "alt_phone", label: "Alt. Phone" },
      {
        name: "zone_id",
        label: "Zone",
        type: "select_setups",
        options: {
          required: true,
          setup: "zones",
        },
        setupKind: "zones",
      },
    ],
  },
  {
    name: "customers",
    singular: "customer",
    fields: [
      { name: "name", label: "Name", options: { required: true } },
      { name: "email", label: "Email", options: { required: true } },
      { name: "phone", label: "Phone", options: { required: true } },
      { name: "alt_phone", label: "Alt. Phone" },
      {
        name: "zone_id",
        label: "Zone",
        type: "select_setups",
        options: {
          required: true,
          setup: "zones",
        },
        setupKind: "zones",
      },
      {
        name: "account_manager_id",
        label: "Account Manager",
        options: { required: false },
        type: "select_users",
      },
    ],
  },
  {
    name: "sites",
    singular: "site",
    fields: [
      { name: "name", label: "Name", cols: 2, options: { required: true } },
    ],
  },
  // {
  //   name: "drivers",
  //   singular: "driver",
  //   fields: [
  //     { name: "name", label: "Name", options: { required: true } },
  //     { name: "license_no", label: "License No" },
  //     { name: "email", label: "Email", options: { required: true } },
  //     { name: "phone", label: "Phone", options: { required: true } },
  //     { name: "alt_phone", label: "Alt. Phone" },
  //   ],
  // },
];

export default function SetupsPage() {
  const [kind, setKind] = useState<SetupKind>("transporters");
  const [openNew, setOpenNew] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openBulk, setOpenBulk] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>(null);
  const [zones, setZones] = useState<any>(null);
  const [totalRecords, setTotalRecords] = useState(1);
  const [exporting, setExporting] = useState(false);
  const { Pagination, pageInfo, setPageInfo } = usePagination(10);
  const setup = SETUP_DATA.find((s) => s.name === kind);
  const [getSetups, { loading }] = useLazyQuery(GET_SETUPS, {
    fetchPolicy: "network-only",
  });
  const [getZoneSetups] = useLazyQuery(GET_SETUPS, {
    fetchPolicy: "network-only",
  });
  const [getUsers, { data: users }] = useLazyQuery(GET_ALL_USERS, {
    fetchPolicy: "network-only",
  });

  const [filter, setFilter] = useState("");

  useEffect(() => {
    getUsers({
      variables: {
        data: {},
      },
    }).then((res) => { });
    getZoneSetups({
      variables: {
        names: ["zones"],
        page: 1,
        limit: 0,
      },
    })
      .then((res) => {
        if (res.data) {
          let setups = res.data.getSetups;
          let sData = setups.records.map((s: any) => {
            let fields = s.fields.reduce(function (map: any, f: any) {
              map[f.name] = f.value;
              return map;
            }, {});

            return {
              ...fields,
              id: s.id,
            };
          });
          setZones(sData);
        }
      })
      .catch((err) => console.error(err));
  }, [kind]);

  function refresh(page: number = 1) {
    getSetups({
      variables: {
        names: [kind],
        page: page,
        limit: pageInfo.limit,
        filter: filter,
      },
    }).then((res) => {
      if (res.data) {
        let setups = res.data.getSetups;

        setTotalRecords(() => setups.totalRecords);
        let sData = setups.records.map((s: any) => {
          let setupId = s.id;
          let fields = s.fields.reduce(function (map: any, f: any) {
            map[f.name] = f.value;
            return map;
          }, {});

          res = {
            ...fields,
            id: setupId,
          };
          return res;
        });
        console.log({ setups, sData });
        setData(sData);
      }
    });
  }

  useEffect(() => {
    setPageInfo((prev) => ({ ...prev, page: 1 }));
  }, [kind, pageInfo.limit]);

  useEffect(() => {
    refresh(pageInfo.page);
  }, [pageInfo, filter]);

  function getUser(userId: string) {
    let found = users.getUsers?.find(
      (u: any) => parseInt(u.id) === parseInt(userId),
    );
    if (!found) return null;
    return {
      id: parseInt(userId),
      name: `${found.firstName} ${found.lastName}`,
    };
  }

  function getZone(id: string) {
    console.log({ zones });
    let found = zones.find((u: any) => parseInt(u.id) === parseInt(id));
    if (!found) return null;

    console.log({ found });
    return {
      id: parseInt(id),
      name: `${found.name}`,
    };
  }

  if (!setup) return null;
  const columns = [{ name: "id", label: "#" }, ...setup.fields].map((c) => {
    if (c.type === "select_users") {
      return {
        ...c,
        render: ({ row }: any) => {
          let usr = getUser(row[c.name]);
          return usr?.name;
        },
      };
    }
    if (c.type === "select_setups") {
      return {
        ...c,
        render: ({ row }: any) => {
          let z = getZone(row[c.name]);
          return z?.name;
        },
      };
    }
    return { ...c };
  });

  async function handleExport() {
    setExporting(true);
    try {
      await downloadExport("setups", { kind, filter });
    } finally {
      setExporting(false);
    }
  }

  console.log({ data });

  return (
    <div>
      <div className="toolbar flex justify-between px-2 py-2 items-center gap-10">
        <h3 className="capitalize">{`List of ${kind.split("_").join(" ")}`}</h3>
        <div className="flex gap-1 flex-1">
          <SearchBox
            className="flex-1"
            defaultValue={filter}
            placeholder="Filter ..."
            onSearch={setFilter}
          />
          <select
            value={kind}
            className="px-2 rounded capitalize border"
            onChange={(ev) => setKind(ev.target.value as SetupKind)}
          >
            {SETUP_DATA.map((s, idx) => (
              <option key={idx} value={s.name}>
                {s.name}
              </option>
            ))}
          </select>
          <button
            className="bg-primary px-2 py-1 rounded text-white"
            onClick={() => setOpenNew(true)}
          >
            Add New
          </button>
          <button
            className="bg-green-400 px-2 py-1 rounded text-white"
            onClick={() => setOpenBulk(true)}
          >
            Bulk Setups
          </button>
        </div>
      </div>
      <Table
        columns={[
          ...columns,
          {
            name: "action",
            render: ({ row }: any) => {
              return (
                <div className="flex gap-2">
                  <button
                    className="rounded border px-2 py-1 bg-gray-100"
                    onClick={() => {
                      setSelected(row);
                      setOpenNew(true);
                    }}
                  >
                    View/Edit
                  </button>
                  <button
                    className="rounded border px-2 py-1 bg-gray-100 text-red-400"
                    onClick={() => {
                      setSelected(row);
                      setOpenDelete(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              );
            },
          },
        ]}
        data={data}
        loading={loading}
        title={<b className="capitalize">{kind.split("_").join(" ")}</b>}
        onExport={handleExport}
        exporting={exporting}
        components={{
          toolbar: () => <p></p>,
        }}
      />
      {openNew && (
        <ManageSetup key={Date.now()}
          selected={selected}
          name={setup.name}
          title={setup.singular}
          fields={setup.fields}
          onComplete={() => {
            setOpenNew(false);
            refresh(1);
            setSelected(null)
          }}
        />
      )}
      {openDelete && (
        <DeleteSetup
          selected={selected}
          name={setup.name}
          title={setup.singular}
          onComplete={() => {
            setOpenDelete(false);
            refresh(1);
            setSelected(null)
          }}
        />
      )}
      {openBulk && (
        <BulkSetups
          name={setup.name}
          title={setup.singular}
          fields={[
            {
              name: "file",
              type: "file",
              label: "Excel File",
              cols: 2,
            },
          ]}
          onComplete={() => {
            setOpenBulk(false);
            refresh(1);
          }}
        />
      )}

      <Pagination totalRecords={totalRecords} />
    </div>
  );
}
